<div class="note" role="listitem" [class.me]="isMine" [class.continued]="note?.continued">
  <div class="note-avatar">
    @if (!note?.continued) {
      <iu-avatar-ui [avatarInfos]="note.author" />
    }
  </div>
  <div class="note-body" data-cy="note-content">
    @if (!note?.continued) {
      <div class="note-meta">
        <span class="note-author">
          {{
            isMine
              ? ('detailsNote.you' | translate)
              : (note?.author?.fullname || ('detailsNote.unknownAuthor' | translate))
          }}
        </span>
        <time class="note-time" [title]="note?.fullDate ?? ''">{{ note?.time ?? note?.createdAt }}</time>
      </div>
    }
    <div class="note-bubble" [attr.title]="note?.continued ? note?.fullDate : null">
      @if (html) {
        <div class="note-text" [innerHTML]="html"></div>
      }
      @if (note?.attachements?.length) {
        <div class="note-attachments">
          @for (attachment of note.attachements; track $index) {
            <button
              type="button"
              class="note-attachment"
              [title]="('detailsNote.download' | translate) + ' ' + (attachment?.filename ?? '')"
              (click)="download(attachment)">
              <i aria-hidden="true" class="note-attachment-icon {{ attachment?.filename | docIcon }}"></i>
              <span class="note-attachment-name">{{ attachment?.filename }}</span>
              <i aria-hidden="true" class="note-attachment-action icon-download"></i>
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>
